<template>
    <RequiredConsentModal
        v-if="isBoosterCCS && !isNlTemporaryConsentBypass"
        v-model="showBoosterConsentModal"
        :consents="boosterConsents"
        :loading="boosterConsentsLoading"
        :submit-type="boosterConsentSubmitType"
        @accepted="handleBoosterConsentAccepted"
    />
    <VeeForm class="form user-form" @submit="submitForm()" v-if="isBoosterCCS">
        <MDBRow>
            <MDBCol col="12" md="12" class="pb-3">
                <h4>{{ $t('points.boosterCCS.personalInfo') }}</h4>
            </MDBCol>
            <MDBCol col="12" md="6" class="pb-3">
                <label for="email" class="label px-3 text-uppercase">
                    {{ $t("account.profile.email") }}*
                </label>
                <input type="email" class="form-control" :placeholder="$t('account.profile.yourEmailAddress')"
                    :aria-label="$t('account.profile.yourEmailAddress')" aria-describedby="basic-addon1"
                    v-model="data.email" disabled id="email" />
                <label for="firstname" class="label px-3 text-uppercase">
                    {{ $t("account.profile.firstname") }} *
                </label>
                <Field type="text" class="form-control" :placeholder="$t('account.profile.yourFirstName')"
                    :aria-label="$t('account.profile.firstname')" aria-describedby="basic-addon1" v-model="data.name"
                    id="firstname" :rules="{ required: true }" name="firstname" :label="$t('account.profile.firstname')"
                    disabled />
                <div>
                    <ErrorMessage name="firstname" class="text-danger text-small text-end m-0 pt-1" />
                </div>
            </MDBCol>
            <MDBCol col="12" md="6" class="pb-3">
                <label for="surname" class="label px-3 text-uppercase">
                    {{ $t("account.profile.surname") }}*
                </label>
                <Field type="text" class="form-control" :placeholder="$t('account.profile.yourLastName')"
                    :aria-label="$t('account.profile.yourLastName')" aria-describedby="basic-addon1"
                    v-model="data.surname" :rules="{ required: true }" name="surname"
                    :label="$t('account.profile.surname')" disabled />
                <div>
                    <ErrorMessage name="surname" class="text-danger text-small text-end m-0 pt-1" />
                </div>
            </MDBCol>
        </MDBRow>
        <MDBRow>
            <MDBCol col="12" md="12" class="pb-3">
                <h4>{{ $t('points.boosterCCS.csNumberTitle') }}</h4>
            </MDBCol>
        </MDBRow>
        <MDBRow v-for="(customer_number, index) in data.accounts_ids" :key="index">
            <MDBCol col="12" md="6" class="pb-3">
                <Field type="number" class="form-control" :placeholder="$t('account.profile.clientNrSingular')"
                    :aria-label="$t('account.profile.clientNrSingular')" aria-describedby="basic-addon1"
                    v-model="data.accounts_ids[index]" :name="'customer_number_' + index" :rules="{ required: true }"
                    :label="$t('account.profile.clientNrSingular')" />
                <div>
                    <ErrorMessage :name="'customer_number_' + index" class="text-danger text-small text-end m-0 pt-1" />
                </div>
            </MDBCol>
        </MDBRow>
        <MDBRow>
            <MDBCol col="12" md="6" class="pb-3">
                <div class="text-uppercase label cursor--pointer" @click="addNewNumberFields()">
                    <img :src="require('@/assets/img/plus_btn_small.svg')" alt="logo" />
                    <span class="ps-2">{{ $t('account.profile.addAnotherCsNumber') }}</span>
                </div>
            </MDBCol>
        </MDBRow>

        <MDBRow>
            <MDBCol col="12" md="12" class="pb-3">
                <h4>{{ $t('points.boosterCCS.filesTitle') }}</h4>
                <div>{{ $t('points.boosterCCS.filesDescription') }}</div>
            </MDBCol>
        </MDBRow>
        <MDBRow v-for="(file, index) in data.documents_tires" :key="index">
            <MDBCol col="12" md="6" class="pb-3">
                <label for="bridgestone_tires_count" class="label px-3 text-uppercase">
                    {{ $t("points.boosterCCS.tyresAmount") }} Bridgestone
                </label>
                <Field type="number" class="form-control" :placeholder="$t('points.boosterCCS.tyresAmount')"
                    :aria-label="$t('points.boosterCCS.tyresAmount')" aria-describedby="basic-addon1"
                    v-model="file.bridgestone_tires_count" id="bridgestone_tires_count"
                    :rules="{ required: true, min_value: 0 }" :name="'bridgestone_tires_count_' + index"
                    :label="$t('points.boosterCCS.tyresAmount')" />
                <div>
                    <ErrorMessage :name="'bridgestone_tires_count_' + index"
                        class="text-danger text-small text-end m-0 pt-1" />
                </div>
            </MDBCol>
            <MDBCol col="12" md="6" class="pb-3">
                <label for="firestone_tires_count" class="label px-3 text-uppercase">
                    {{ $t("points.boosterCCS.tyresAmount") }} Firestone
                </label>
                <Field type="number" class="form-control" :placeholder="$t('points.boosterCCS.tyresAmount')"
                    :aria-label="$t('points.boosterCCS.tyresAmount')" aria-describedby="basic-addon1"
                    v-model="file.firestone_tires_count" id="firestone_tires_count"
                    :rules="{ required: true, min_value: 0 }" :name="'firestone_tires_count_' + index"
                    :label="$t('points.boosterCCS.tyresAmount')" />
                <div>
                    <ErrorMessage :name="'firestone_tires_count_' + index"
                        class="text-danger text-small text-end m-0 pt-1" />
                </div>
            </MDBCol>
            <MDBCol col="12" md="6" class="pb-3">
              <InputFile :label="$t('points.boosterCCS.fileUpload')"
                         :placeholder="$t('points.boosterCCS.fileUploadPlaceholder')" :name="'file_' + index"
                         :rules="{ required: true }" @change="addFile($event, index)" :index="index"/>
            </MDBCol>
            <MDBCol col="12" md="6" class="pb-3 d-flex flex-column justify-content-center">
                <img src="@/assets/img/icons/trash.svg" alt="trash" class="icon-container mt-3"
                    @click="deleteFileField(index)" v-if="data.documents_tires.length > 1 && index != 0" />
            </MDBCol>
        </MDBRow>
        <MDBRow>
            <MDBCol col="12" md="6" class="pb-3">
                <div class="text-uppercase label cursor--pointer" @click="addNewFileFields()">
                    <img :src="require('@/assets/img/plus_btn_small.svg')" alt="logo" />
                    <span class="ps-2">{{ $t('points.boosterCCS.addAnotherFile') }}</span>
                </div>
            </MDBCol>
        </MDBRow>

        <div class="pt-3">
            <MDBBtn type="submit" color="danger" :disabled="loading"
                class="d-flex justify-content-center align-items-center">
                <span>{{ $t("global.buttons.send") }}</span>
            </MDBBtn>
        </div>
        <MDBRow v-if="submitted">
            <MDBCol col="12" class="pt-3">
                <div v-html="$t('points.boosterCCS.confrimationMessage')"></div>
            </MDBCol>
        </MDBRow>

    </VeeForm>
    <PageNotFound v-else />
</template>

<script setup>
import PageNotFound from "@/views/404.vue";
import RequiredConsentModal from "@/components/Consents/RequiredConsentModal.vue";
import { useRequiredConsents } from "@/composables/useRequiredConsents";
import { CONSENT_TYPE } from "@/configs/constants";
import { Form as VeeForm, Field, ErrorMessage, defineRule } from "vee-validate";
import { required, min_value } from "@vee-validate/rules";
import { MDBCol, MDBRow, MDBBtn } from "mdb-vue-ui-kit";
import { BoosterService } from "@/services/booster.service";
import TokenService from "@/services/storage.service";

import { useStore } from "vuex";
import { computed, ref, onMounted, watch } from "vue";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import { useI18n } from "vue-i18n";
import InputFile from "../InputFile.vue";
const { t } = useI18n()

defineRule("required", required);
defineRule("min_value", min_value);
const store = useStore();
const data = ref({
    'documents_tires': [{
        'file': '',
        'bridgestone_tires_count': 0,
        'firestone_tires_count': 0,
    }],
    'name': "",
    'surname': "",
    'email': "",
    'accounts_ids': [''],
    'description': null,
})
const loading = ref(false)
const submitted = ref(false)

const user = computed(() => store.getters.getMe);
const urlTenantId = computed(
    () =>
        window.location.href.match(/plus-([a-z]{2})\.bsplus\.bridgestone\.eu/i)?.[1]?.toUpperCase() || ""
);
const tenantId = computed(() =>
    String(store.getters.tenantId || urlTenantId.value || "").trim().toUpperCase()
);
const currentLocale = computed(() =>
    String(store.getters.getCurrentLocale || localStorage.getItem("currentLocale") || "").trim()
);
const isNlTemporaryConsentBypass = computed(
    () => tenantId.value === "NL" || currentLocale.value === "nl-NL"
);
const isBoosterCCS = computed(() =>
    user.value?.compaings?.some(element => element.slug === 'booster-ccs')
);
const {
    consents: boosterConsents,
    loading: boosterConsentsLoading,
    hasPendingRequired: hasBoosterPending,
    resolvedConsentApiType,
    fetchConsents: fetchBoosterConsents,
} = useRequiredConsents(CONSENT_TYPE.BOOSTER_CCS_FORM, {
    fetchWithoutPendingMatch: true,
    enabled: computed(() => isBoosterCCS.value && !isNlTemporaryConsentBypass.value),
});
const showBoosterConsentModal = ref(false);
const refreshingBoosterConsents = ref(false);

const boosterConsentSubmitType = computed(
    () => resolvedConsentApiType.value ?? CONSENT_TYPE.BOOSTER_CCS_FORM
);

watch(
    [hasBoosterPending, () => isBoosterCCS.value, isNlTemporaryConsentBypass],
    ([pending, eligible, disableNlConsents]) => {
        if (!eligible || disableNlConsents || refreshingBoosterConsents.value) {
            showBoosterConsentModal.value = false;
            return;
        }
        showBoosterConsentModal.value = pending;
    },
    { immediate: true }
);

const handleBoosterConsentAccepted = async () => {
    refreshingBoosterConsents.value = true;
    showBoosterConsentModal.value = false;
    try {
        await store.dispatch("me");
        await fetchBoosterConsents();
    } catch (err) {
        console.error("Error after booster CCS consents:", err);
    } finally {
        refreshingBoosterConsents.value = false;
    }
};

const fillPersonalData = () => {
    const profile = user.value?.profile;
    if (!profile) {
        return;
    }

    data.value.name = profile.forename ?? "";
    data.value.surname = profile.name ?? "";
    data.value.email = user.value?.email ?? "";
};

watch(user, () => {
    fillPersonalData();
}, { immediate: true });

const addNewNumberFields = () => {
    data.value.accounts_ids.push("");
};

const addNewFileFields = () => {
    data.value.documents_tires.push({
        'file': '',
        'bridgestone_tires_count': 0,
        'firestone_tires_count': 0,
    });
};

const deleteFileField = (index) => {
    if (data.value.documents_tires.length > 1 && index > -1 && index < data.value.documents_tires.length) {
        data.value.documents_tires.splice(index, 1);
    }
};

const addFile = async (event, index) => {
    if (event.target.files.length > 0) {
        data.value.documents_tires[index].file = event.target.files[0];
    }
};

const submitForm = async () => {
    loading.value = true
    const formData = new FormData();

    data.value.documents_tires.forEach((doc, index) => {
        formData.append(`documents_tires[${index}][file]`, doc.file);
        formData.append(`documents_tires[${index}][bridgestone_tires_count]`, doc.bridgestone_tires_count);
        formData.append(`documents_tires[${index}][firestone_tires_count]`, doc.firestone_tires_count);
    });

    formData.append('name', data.value.name);
    formData.append('surname', data.value.surname);
    formData.append('email', data.value.email);

    data.value.accounts_ids.forEach(id => {
        formData.append('accounts_ids[]', id);
    });

    formData.append('description', data.value.description || '');

    try {
        const response = await BoosterService.storeDocuments(formData)
        if (response.status == 201) {
            data.value = {
                'files': [''],
                'name': user.value?.profile?.forename ?? '',
                'surname': user.value?.profile?.name ?? '',
                'email': user.value?.email ?? '',
                'accounts_ids': [''],
                'bridgestone_tires_count': 0,
                'firestone_tires_count': 0,
                'description': null,
            }

            toast(t("toast.requestSent"), {
                type: "success",
                theme: "colored",
                transition: toast.TRANSITIONS.SLIDE,
                position: toast.POSITION.BOTTOM_RIGHT,
            });

            submitted.value = true
        }
    } catch (error) {
        console.error(error);

    }

    loading.value = false
};

onMounted(async () => {
    if (!user.value && TokenService.getToken()) {
        await store.dispatch("me").catch(() => null);
    }
    fillPersonalData();
})
</script>